import {z} from 'zod'
import {zForecastFetchedBase} from './forecastTypes'
import {upgradeBoundsVersion, zQuestionCfg, zQuestionCfgShape, zQuestionPublicationCfg} from './question'
import {zSubqFetched} from './subq'
import {JsonObject} from '../type'
import {isNonNullish, omit} from 'remeda'
import {uri} from '../uri'

export const zQuestionPublished = z.object({
  question: z.preprocess(
    upgradeBoundsVersion,
    z.object({
      ...omit(zQuestionCfgShape, ['publish', 'liveView', 'tasked', 'due', 'owner', 'status']),
      publish: z
        .object({
          publications: z.record(zQuestionPublicationCfg).default({})
        })
        .default({})
    })
  ),
  subquestions: z.array(zSubqFetched),
  forecasts: z.array(zForecastFetchedBase)
  // subset of publications relevant to a published question
})
export type QuestionPublished = z.infer<typeof zQuestionPublished>

/** Publish question shared utilities to retreive and store publish data */
export namespace PublishStore {
  export type PathCfg = {
    question_id: string
    ts?: string
  }
  export const path = (cfg: PathCfg) =>
    `question-results/${[cfg.question_id, cfg.ts].filter(isNonNullish).join('/')}.json`
  export const url = (cfg: PathCfg & {url: string}) => uri(cfg.url).addPath(path(cfg)).url
  export const parse = (cfg: JsonObject) => zQuestionPublished.parse(cfg)
}
